import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ErrorMessage } from '@hookform/error-message';
import { Controller, useFormContext } from 'react-hook-form';
import { ErrorMessageDisplay } from '../../../atoms/Input';
import { FileUpload } from '../../FileUpload';
export const FileUploadController = props => {
    const { errors, watch } = useFormContext();
    watch(props.name);
    const onDeleteHandler = (index, value, onChange) => {
        onChange([...value.filter((file, _index) => _index !== index)]);
        if (props.onDelete) {
            props.onDelete();
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(Controller, { name: props.name, defaultValue: props.defaultValue, rules: props.rules, disabled: props.disabled, render: ({ value, onChange, onBlur }) => {
                    var _a;
                    return (_jsx(FileUpload, Object.assign({ disabled: props.disabled, numOfFiles: props.numOfFiles, value: value, onChange: (files) => (value ? onChange([...value, ...files]) : onChange([...files])), onDelete: (index) => onDeleteHandler(index, value, onChange), onBlur: onBlur, error: props.error
                            ? (_a = Object.keys(errors).find(a => errors[a].type === 'extensions') === 'factuurDocument') !== null && _a !== void 0 ? _a : false
                            : undefined }, { children: props.children })));
                } }), _jsx(ErrorMessage, { errors: errors, name: props.name, render: ({ message }) => _jsx(ErrorMessageDisplay, { id: props.name, message: message }) })] }));
};
